export const hexToHsl = (hex) => {
  let r = parseInt(hex.substring(1, 3), 16) / 255;
  let g = parseInt(hex.substring(3, 5), 16) / 255;
  let b = parseInt(hex.substring(5, 7), 16) / 255;
  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
    case r:
      h = (g - b) / d + (g < b ? 6 : 0);
      break;
    case g:
      h = (b - r) / d + 2;
      break;
    case b:
      h = (r - g) / d + 4;
      break;
    }
    h /= 6;
  }
  return {h, s, l};
};


export const mostColorfulHex = (hex1, hex2) => {
  if (!hex1 || !hex2) return hex1 || hex2;
  if (hex1 === hex2) return hex1;

  const hsl1 = hexToHsl(hex1);
  const hsl2 = hexToHsl(hex2);

  if (hsl1.s > hsl2.s || (hsl1.s === hsl2.s && hsl1.l < hsl2.l)) return hex1;
  return hex2;
};

export const darkestHex = (hex1, hex2) => {
  if (!hex1 || !hex2) return hex1 || hex2;
  if (hex1 === hex2) return hex1;

  const hsl1 = hexToHsl(hex1);
  const hsl2 = hexToHsl(hex2);

  if (hsl1.l < hsl2.l) return hex1;
  return hex2;
};

export const addOpacityToHex = (hex, opacity) => {
  if (hex.indexOf("#") === 0) hex = hex.slice(1);
  const alphaHex = Math.round(opacity * 255).toString(16).padStart(2, "0");
  if (hex.length === 3) hex = hex.split("").map(char => char + char).join("");
  return "#" + hex + alphaHex;
};

export const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) hex = hex.split("").map(char => char + char).join("");

  // Parse the hex string into RGB values
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  return [r, g, b];
};

const luminance = (r, g, b) => {
  let a = [r, g, b].map(function(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};


/**
 * @param hex1
 * @param hex2
 * @returns {number} // 1 <= contrast ratio <= 21
 */
export const getContrastRatio = (hex1, hex2) => {
  let rgb1 = hexToRgb(hex1);
  let rgb2 = hexToRgb(hex2);

  let lum1 = luminance(rgb1[0], rgb1[1], rgb1[2]) + 0.05;
  let lum2 = luminance(rgb2[0], rgb2[1], rgb2[2]) + 0.05;

  return lum1 > lum2 ? lum1 / lum2 : lum2 / lum1;
};
